// extracted by mini-css-extract-plugin
export default {"noFoodItemFound":"notFound_noFoodItemFound__VAhj7"};